import PhotoHelp from "./PhotoHelp";
import PublicationSuccess from './PublicationSuccess';

const createPhotoHelp = [
    {
        title: 'Enter your ad text',
        progress: { title: 'Photo help', step: 2 },
        component: PhotoHelp, valid: true, required: true,
    },
    {
        progress: { title: 'Thank you', step: 3 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default createPhotoHelp;
